import React from "react";
import { createPortal } from "react-dom";

const Portal = ({ children }: { children: React.ReactNode }) => {
  const portalRoot = typeof window !== "undefined" ? document.getElementById("portal-root") || document.body : null;

  return portalRoot ? createPortal(children, portalRoot) : null;
};

export default Portal;
